module.exports = __webpack_public_path__ + "static/img/wenhao.f63b0b1f.svg";